import { render, staticRenderFns } from "./CommanderDamageTable.vue?vue&type=template&id=3766c4f7&scoped=true&"
import script from "./CommanderDamageTable.vue?vue&type=script&lang=js&"
export * from "./CommanderDamageTable.vue?vue&type=script&lang=js&"
import style0 from "./CommanderDamageTable.vue?vue&type=style&index=0&id=3766c4f7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3766c4f7",
  null
  
)

export default component.exports